import script from "./AudioPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./AudioPlayer.vue?vue&type=style&index=0&id=121f3d11&scoped=true&lang=scss"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121f3d11"]])

export default __exports__